import React, { useEffect, useCallback, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useHistory, Link } from "react-router-dom";
import {
    FiFolder,
    FiPlusCircle,
    FiLink,
    FiDownload,
    FiUpload,
} from "react-icons/fi";

import Container from "../../../components/Admin/Container";
import Table, { ResponsiveTable } from "../../../components/Table";
import DocInput from "../../../components/ProductsDocInput";

import DataTables from "../../../modules/DataTables";

import useLoading from "../../../hooks/useLoading";

import api from "../../../service/api";
import { canEditProducts } from "../../../service/authorization";

import { exportProductsToXlsx } from "../../../service/productsImportExport";
import Notification, { Error as notificationError } from "../../../modules/Notifications";
import ImportProductsModal from "../../../components/Admin/ImportProductsModal";

const ShowProducts = () => {
    const history = useHistory();
    const isEditable = canEditProducts();

    const { loading } = useLoading();
    const [selectedCount, setSelectedCount] = useState(0);
    const [showImport, setShowImport] = useState(false);
    const selectedIdsRef = useRef(new Set());

    const toggleSelected = useCallback((id, checked) => {
        const set = selectedIdsRef.current;
        if (checked) set.add(id);
        else set.delete(id);
        setSelectedCount(set.size);
    }, []);

    const setReactComponentinTable = useCallback(() => {
        const handleEdit = (id) => {
            history.push(`/ctop/produto/${id}`);
        };

        const setReactComponentinTable = () => {
            function setOpenButtons() {
                const editarEls = document.querySelectorAll(".editar");

                for (const editarEl of editarEls) {
                    ReactDOM.render(
                        <FiFolder
                            className="cursor-pointer"
                            onClick={() => {
                                handleEdit(editarEl.dataset.id);
                            }}
                        />,
                        document.getElementById(editarEl.id)
                    );
                }
            }

            function setDoc1() {
                const docEls = document.querySelectorAll(".cdoc-1");

                docEls.forEach((docEl) => {
                    const { id, file } = docEl.dataset;

                    ReactDOM.render(
                            <DocInput
                                {...{
                                    id,
                                    uploadedFile: file,
                                    type: "CDOC1",
                                    reload: index,
                                    isReadOnly: !isEditable,
                                }}
                        />,
                        document.getElementById(docEl.id)
                    );
                });
            }

            function setDoc2() {
                const docEls = document.querySelectorAll(".cdoc-2");

                docEls.forEach((docEl) => {
                    const { id, file } = docEl.dataset;

                    ReactDOM.render(
                            <DocInput
                                {...{
                                    id,
                                    uploadedFile: file,
                                    type: "CDOC2",
                                    reload: index,
                                    isReadOnly: !isEditable,
                                }}
                        />,
                        document.getElementById(docEl.id)
                    );
                });
            }

            function setDoc3() {
                const docEls = document.querySelectorAll(".cdoc-3");

                docEls.forEach((docEl) => {
                    const { id, file } = docEl.dataset;

                    ReactDOM.render(
                            <DocInput
                                {...{
                                    id,
                                    uploadedFile: file,
                                    type: "CDOC3",
                                    reload: index,
                                    isReadOnly: !isEditable,
                                }}
                        />,
                        document.getElementById(docEl.id)
                    );
                });
            }

            function setDoc4() {
                const docEls = document.querySelectorAll(".cdoc-4");

                docEls.forEach((docEl) => {
                    const { id } = docEl.dataset;

                    ReactDOM.render(
                        <FiLink
                            className="link"
                            onClick={() => {
                                history.push(`/ctop/produto/${id}?goto=cdoc4`);
                            }}
                        />,
                        document.getElementById(docEl.id)
                    );
                });
            }

            function setRowSelects() {
                const els = document.querySelectorAll(".row-select");
                els.forEach((el) => {
                    const id = Number(el.dataset.id);
                    const checked = selectedIdsRef.current.has(id);
                    ReactDOM.render(
                        <input
                            key={`${id}-${checked ? 1 : 0}`}
                            type="checkbox"
                            defaultChecked={checked}
                            aria-label={`Selecionar produto ${id}`}
                            onChange={(e) => {
                                toggleSelected(id, e.target.checked);
                            }}
                        />,
                        document.getElementById(el.id)
                    );
                });
            }

            setOpenButtons();
            setDoc1();
            setDoc2();
            setDoc3();
            setDoc4();
            setRowSelects();
        };

        setReactComponentinTable();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, toggleSelected]);

    const orderProducts = (products = []) => {
        const safeProducts = Array.isArray(products) ? products : [];

        return safeProducts.sort((a, b) => {
            const ordemA = a?.linha?.ordem ?? Number.MAX_SAFE_INTEGER;
            const ordemB = b?.linha?.ordem ?? Number.MAX_SAFE_INTEGER;

            return ordemA - ordemB;
        });
    };

    const index = useCallback(() => {
        async function index() {
            const idLoading = loading();
            try {
                const response = await api.get("/produtos?_limit=-1");

                const orderedProducts = orderProducts(response.data);

                let serializedData = orderedProducts.map((data) => {
                    const {
                        id: ID,
                        Titulo,
                        CDOC1,
                        CDOC2,
                        CDOC3,
                    } = data;
                    const Linha = data?.linha?.Linha ?? "-";

                    return {
                        ID,
                        Sel: `<div class="row-select" data-id="${ID}" id="rowsel-${ID}"></div>`,
                        Titulo,
                        Linha,
                        CDOC1: `<div class="cdoc-1" data-id="${ID}" data-file="${CDOC1}" id="cdoc1-${ID}"></div>`,
                        CDOC2: `<div class="cdoc-2" data-id="${ID}" data-file="${CDOC2}" id="cdoc2-${ID}"></div>`,
                        CDOC3: `<div class="cdoc-3" data-id="${ID}" data-file="${CDOC3}" id="cdoc3-${ID}"></div>`,
                        CDOC4: `<div class="cdoc-4" data-id="${ID}" id="cdoc4-${ID}"></div>`,
                        Abrir: `<div class="editar" data-id="${ID}" id="editar-${ID}"></div>`,
                    };
                });

                selectedIdsRef.current.clear();
                setSelectedCount(0);

                DataTables(
                    "#products-table",
                    serializedData,
                    [
                        {
                            title: "",
                            data: "Sel",
                            orderable: false,
                            width: "20px",
                        },
                        { title: "Titulo", data: "Titulo" },
                        { title: "Linha", data: "Linha" },
                        { title: "Literatura", data: "CDOC1" },
                        { title: "FDS", data: "CDOC2" },
                        { title: "Laudos", data: "CDOC3" },
                        {
                            title: "Material publicitário de apoio",
                            data: "CDOC4",
                        },
                        { title: "Abrir", data: "Abrir" },
                    ],
                    () => {
                        setReactComponentinTable();
                    },
                    {
                        ordering: true,
                        order: [[1, "asc"]],
                    }
                );
            } catch (error) {
                console.log(error);
            } finally {
                loading(idLoading);
            }
        }

        index();
    }, [loading, setReactComponentinTable, setSelectedCount]);

    useEffect(() => {
        index();
    }, [index]);

    const handleExport = async () => {
        const idLoading = loading();
        try {
            const today = new Date().toISOString().slice(0, 10);
            const ids = Array.from(selectedIdsRef.current);

            if (ids.length > 0) {
                const fresh = await Promise.all(
                    ids.map((pid) => api.get(`/produtos/${pid}`).then((r) => r.data))
                );
                await exportProductsToXlsx(
                    fresh,
                    `produtos-selecionados-${today}.xlsx`
                );
            } else {
                const { data } = await api.get("/produtos?_limit=-1");
                await exportProductsToXlsx(data, `produtos-${today}.xlsx`);
            }
            Notification("success", "Planilha gerada com sucesso");
        } catch (err) {
            console.error("[handleExport] falha", err);
            if (err && err.request) {
                notificationError(err);
            } else {
                Notification("error", err && err.message ? err.message : "Falha ao gerar planilha");
            }
        } finally {
            loading(idLoading);
        }
    };

    return (
        <Container pageTitle="Listar Produtos">
            <div
                className="grid-add"
                style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}
            >
                {isEditable && (
                    <Link to="/ctop/produto" className="add" aria-label="Adicionar produto">
                        <FiPlusCircle />
                    </Link>
                )}
                <button
                    type="button"
                    className={`btn-ntn ${
                        selectedCount > 0 ? "btn-ntn--active" : "btn-ntn--secondary"
                    }`}
                    onClick={handleExport}
                >
                    <FiDownload />
                    {selectedCount > 0 ? (
                        <>
                            <span>Exportar selecionados</span>
                            <span className="btn-ntn__badge">{selectedCount}</span>
                        </>
                    ) : (
                        <span>Exportar (todos)</span>
                    )}
                </button>
                {isEditable && (
                    <button
                        type="button"
                        className="btn-ntn btn-ntn--primary"
                        onClick={() => {
                            if (!canEditProducts()) return;
                            setShowImport(true);
                        }}
                    >
                        <FiUpload />
                        <span>Importar</span>
                    </button>
                )}
            </div>
            <ResponsiveTable>
                <Table id="products-table"></Table>
            </ResponsiveTable>
            <ImportProductsModal
                show={showImport}
                onClose={() => setShowImport(false)}
                onImported={() => {
                    setShowImport(false);
                    index();
                }}
            />
        </Container>
    );
};

export default ShowProducts;
